<template>
    <div class="chat-wind">
      <h1>Chat App</h1>
      <select v-model="selectedUser" @change="changeUser">
        <option v-for="user in userList" :key="user.Id" :value="user.Id">{{ user.CompanyName }}</option>
      </select>
      <div v-if="selectedUser">
        <h4>Conversation with {{ selectedUser }}</h4>
          <div class="message-container">
            <div class="message-box right" v-for="(message, index) in messag" :key="index" v-if="message.sender === currentUser">
              <div class="message">{{ message.content }}</div>
            </div>
            <div class="message-box left" v-for="(message, index) in messag" :key="index" v-if="message.sender !== currentUser">
              <div class="message">{{ message.content }}</div>
            </div>
            <div class="input-container">
              
              <textarea border-radius="5px" rows="5" v-model="newMessage"></textarea>
              <button @click="sendMessage">Send message</button>
            </div>
          </div>
        <!-- <ul>
          <li v-for="message in messages">{{ message }}</li>
        </ul>
        <form @submit.prevent="sendMessage">
          <input type="text" v-model="newMessage" placeholder="Type your message" />
          <button type="submit">Send</button>
        </form> -->
      </div>
    </div>
  </template>




  
  <script>
  import axios from 'axios'
  import { mapState } from "vuex";
  import Vue from "vue";
  export default {
    data() {
      return {
        // users: ["User 1", "User 2", "User 3"],
        userList: [],
        selectedUser: null,
        // messages: [],
        
        // newMessage: "",
        messag: [
        // {
        //   content: "Hello!",
        //   sender: "user2",
        // },
        // {
        //   content: "Hi there!",
        //   sender: "user1",
        // },
        
      ],
      newMessage: "",
      currentUser: "user1",
      user: JSON.parse(localStorage.getItem("user"))
      };
    },

    mounted(){
      axios.get('http://localhost:51239/api/public/category/company/')
      .then(response => {
        console.log("Hello = "+response.data.ResponseMessage);
        this.userList = response.data.Result;
        console.log("User List  =  ", this.userList);
      })
      .catch(error => {
        console.log(error)
      })
    },

    methods: {
      changeUser() {
        this.messages = []; // Clear the messages when the user changes
      },
      // sendMessage() {
      //   this.messages.push(`You: ${this.newMessage}`); // Add the user's message to the conversation
      //   this.newMessage = ""; // Clear the input field
      // },
    //   sendMessage() {
    //   this.messag.push({
    //     content: this.newMessage,
    //     sender: this.currentUser,
    //   });
    //   this.newMessage = "";
    // },

    async sendMessage() {
      console.log('The data is : ', this.selectedUser, this.newMessage, this.user.id );
      // if (this.message == "" || this.message == null) {
      //   this.error = "Message is empty";
      //   return;
      // } else {
      //   this.error = "";
      // }

      // await this.$confirm("", "Are you sure to submit your RFQ?");
      //console.log(r);
      await this.$store.dispatch("products/addChat", {
        selectedUser: this.selectedUser,
        messag: this.newMessage,
        fromUserId: this.user.id
      });

    }
  




    },
  };
  </script>
  
  <style>

.message-container {
  display: flex;
  flex-direction: column;
  height: 50%;
}

.message-box {
  display: flex;
  justify-content: center;
  margin: 10px;
}

.right {
  align-self: flex-end;
}

.left {
  align-self: flex-start;
}

.message {
  background-color: #eee;
  padding: 10px;
  border-radius: 10px;
  max-width: 80%;
}

.input-container {
  display: flex;
  align-items: center;
  margin: 10px;
}

textarea {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  border: none;
  resize: none;
  font-size: 16px;
  height: 60px;
  margin-right: 10px;
}

button {
  padding: 10px;
  border-radius: 10px;
  border: none;
  background-color: #007aff;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

.chat-wind {
  /* position: fixed; */
  bottom: 100px;
  right: 20px;
  width: 600px;
  height: 800px;
  background-color: white;
  border: 2px solid black;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.5);
}
</style>